import React from 'react';
import { css } from 'emotion';

import theme from 'site-react/theme';
import { footerSmallTextStyle } from './Footer.styles';

import copyrightYear from './copyrightYear';

const copyrightSpanStyle = css`
  ${footerSmallTextStyle};
  color: ${theme.colors.neutral400};
  padding-bottom: ${theme.spacing.lg}px;
`;

const FooterCopyrightBlock = () => (
  <span className={copyrightSpanStyle}>
    Copyright © HubbleHQ {copyrightYear()}
  </span>
);

export default FooterCopyrightBlock;
